// Formatting utilities for discipline queue

export const resolveDate = (value) => {
  if (!value) return null;
  let date;
  if (value instanceof Date) {
    date = value;
  } else if (typeof value?.toDate === 'function') {
    date = value.toDate();
  } else if (Number.isFinite(value?.seconds)) {
    date = new Date((value.seconds * 1000) + Math.floor((value.nanoseconds || 0) / 1e6));
  } else {
    date = new Date(value);
  }
  return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
};

// Format timestamp to show actual time
export const formatTimestamp = (timestamp) => {
  const date = resolveDate(timestamp);
  if (!date) return 'Date unavailable';
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // For today: show time only (9:45 AM)
  if (date >= startOfToday) {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  // For this week: show day and time (Mon 9:45 AM)
  const startOfThisWeek = new Date(startOfToday);
  startOfThisWeek.setDate(startOfThisWeek.getDate() - now.getDay());
  if (date >= startOfThisWeek) {
    return date.toLocaleString('en-US', {
      weekday: 'short',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  // For older: show date (Jan 15, 9:45 AM)
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
